import React from "react"
import { formatDate } from "src/main/Billing/Items/helpers"
import PaymentMethodDescription from "src/main/Billing/Payments/PaymentMethodDescription"
import PaymentStatusBadge from "src/main/Billing/Payments/PaymentStatusBadge"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

export const buildColumns = ({ presentmentCurrency }) => [
  {
    key: "id",
    header: "Invoice",
    width: "20%",
    cardRole: "title",
    render: (invoice) => <div className="truncate">{invoice.id}</div>,
  },
  {
    key: "status",
    sortKey: "computed_status",
    header: "Status",
    sortable: true,
    cardRole: "badge",
    render: (invoice) => <PaymentStatusBadge payment={invoice} />,
  },
  {
    key: "dueDate",
    sortKey: "due_date",
    header: "Due Date",
    sortable: true,
    cardRole: "detail",
    render: (invoice) => (invoice.dueDate ? formatDate(invoice.dueDate) : "-"),
  },
  {
    key: "totalAmount",
    sortKey: "total_amount",
    header: "Total",
    sortable: true,
    cardRole: "detail",
    render: (invoice) =>
      formatCurrencyFromMinorUnits({
        amount: invoice.totalAmount,
        currency: presentmentCurrency,
      }),
  },
  {
    key: "balance",
    sortKey: "balance",
    header: "Balance",
    sortable: true,
    cardRole: "detail",
    render: (invoice) =>
      formatCurrencyFromMinorUnits({
        amount: invoice.balance,
        currency: presentmentCurrency,
      }),
  },
  {
    key: "paymentMethod",
    header: "Method",
    width: "16%",
    cardRole: "detail",
    render: (invoice) => (
      <PaymentMethodDescription paymentMethod={invoice.paymentMethod} />
    ),
  },
  {
    key: "source",
    header: "Source",
    cardRole: "subtitle",
    render: (invoice) => {
      const sourceTypeDisplay =
        invoice.sourceType === "Reservation"
          ? "Reservation"
          : invoice.sourceType
      return (
        <div>
          <span className="text-gray-900">#{invoice.sourceId}</span>
          <div className="text-xs text-gray-600">{sourceTypeDisplay}</div>
        </div>
      )
    },
  },
]
